<script>
    import axios from 'axios'
    import AutoComplete from './AutoComplete'

    export default {
        components: {
            AutoComplete
        },
        name: "InviteMemberModal",
        props: ["modalParams"],
        template: "#invite-member-modal",

        data() {
            return {
                membersToInvite: []
            };
        },
        computed: {
            limitReached() {
                return this.membersToInvite.length > 9;
            }
        },
        methods: {
            submit() {
                if (!this.membersToInvite.length && !this.$refs.csvUpload.files.length)
                    return;

                let apiEndpoint = "/groups/" + Grabcad.currentGroup + "/invite";
                axios
                    .post(apiEndpoint, this.buildFormData())
                    .then(this.onRequestSuccess)
                    .catch(this.onRequestError);
            },
            buildFormData() {
                let formData = new FormData();
                let fileElement = this.$refs.csvUpload;

                if (fileElement && fileElement.files.length) {
                    let newFile = fileElement.files[0];
                    formData.append("uploaded_csv", newFile);
                }
                formData.append(
                    "members_to_invite",
                    JSON.stringify(this.membersToInvite)
                );
                return formData;
            },
            onRequestSuccess(response) {
                this.$eventHub.$emit("addAlert", {
                    type: "success",
                    message: response.data.msg
                });
                this.$emit("cancel");
            },
            onRequestError() {
                this.$eventHub.$emit("addAlert", {
                    type: "error",
                    message: "Something went wrong. Please refresh the page and try again!"
                });
            }
        }
    };
</script>
